import Griddle, { RowDefinition } from 'griddle-react';
import _ from 'lodash';
import React from 'react';
import { ERROR } from '../../Shared/Constants/LanguageKeys';
import { FILTER } from '../../Shared/Constants';
import { MobileCard } from '../../Shared/DataTable';
import { toastError } from '../../Shared/Forms';
import { withLoader } from '../../Shared/Loading';
import { DirectionContextConsumer } from '../DirectionContext';
import { getColDefinition, getCustomComponents } from './BaseTable';
import { withTranslation } from 'react-i18next';

const getGridData = async (dataType, currentPage, pageSize, filterText, sortColumn, sortDir, extraGetParams, currLang) => {
    await delay(700);
    if (dataType === "entity") {
        return {
            "Data": [
                {
                    EntityNumber: "ALC202141403",
                    EntityName: "Sea Salty Bakes Pte Ltd",
                    EntityType: "Local Company",
                    Status: "Struck Off",
                    StartDate:"29-Nov-2021",
                    IssuedDate: "29-Nov-2021",
                    ExpiryDate: "29-Nov-2023",
                    EntityDocuments: [{
                        FileDescription: "Entity Doc1", Filename: "entity_doc1.pdf", Id: 1, ContentType: "application/pdf", ContentLength: 0
                    },
                    {
                        FileDescription: "Entity Doc2", Filename: "entity_doc2.pdf", Id: 2, ContentType: "application/pdf", ContentLength: 0
                    }],
                    PostalCode: "642800", 
                    StreetName: "Westridge", 
                    State: "Singapore", 
                    Country: "Singapore",
                    PrimaryActivity: "Maecenas venenatis tellus vitae massa dapibus auctor.",
                    PrimaryActivityDescription: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
                    SecondaryActivity: "Aliquam ac nulla vitae mi auctor accumsan.",
                    SecondaryActivityDescription: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy"
                },
                {
                    EntityNumber: "ALC201128431",
                    EntityName: "Salty Investment Pte Ltd",
                    EntityType: "Local Company",
                    Status: "Food Shop Licences",
                    StartDate:"16-Sep-2011",
                    IssuedDate: "16-Sep-2011",
                    ExpiryDate: "16-Sep-2031",
                    EntityDocuments: [{
                        FileDescription: "Entity Doc3", Filename: "entity_doc3.pdf", Id: 3, ContentType: "application/pdf", ContentLength: 0
                    },
                    {
                        FileDescription: "Entity Doc4", Filename: "entity_doc4.pdf", Id: 4, ContentType: "application/pdf", ContentLength: 0
                    }],
                    PostalCode: "250048", 
                    StreetName: "Meadow Vale", 
                    State: "Singapore", 
                    Country: "Singapore",
                    PrimaryActivity: "Maecenas venenatis tellus vitae massa dapibus auctor.",
                    PrimaryActivityDescription: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
                    SecondaryActivity: "Aliquam ac nulla vitae mi auctor accumsan.",
                    SecondaryActivityDescription: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy"
                },
                {
                    EntityNumber: "ARB52894659",
                    EntityName: "Healthy Wealthy & Wise Marketing",
                    EntityType: "Business",
                    Status: "Cancelled",
                    StartDate:"09-Jun-1999",
                    IssuedDate: "09-Jun-1999",
                    ExpiryDate: "09-Jun-2000",
                    EntityDocuments: [{
                        FileDescription: "Entity Doc5", Filename: "entity_doc5.pdf", Id: 5, ContentType: "application/pdf", ContentLength: 0
                    },
                    {
                        FileDescription: "Entity Doc6", Filename: "entity_doc6.pdf", Id: 6, ContentType: "application/pdf", ContentLength: 0
                    }],
                    PostalCode: "404605", 
                    StreetName: "Brickson Park", 
                    State: "Singapore", 
                    Country: "Singapore",
                    PrimaryActivity: "Maecenas venenatis tellus vitae massa dapibus auctor.",
                    PrimaryActivityDescription: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
                    SecondaryActivity: "Aliquam ac nulla vitae mi auctor accumsan.",
                    SecondaryActivityDescription: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy"
                },
                {
                    EntityNumber: "ALC201135431",
                    EntityName: "Sea Properties Ltd",
                    EntityType: "Local Company",
                    Status: "Food Shop Licences",
                    StartDate:"16-Sep-2011",
                    IssuedDate: "16-Sep-2011",
                    ExpiryDate: "16-Sep-2031",
                    EntityDocuments: [{
                        FileDescription: "Entity Doc3", Filename: "entity_doc3.pdf", Id: 3, ContentType: "application/pdf", ContentLength: 0
                    },
                    {
                        FileDescription: "Entity Doc4", Filename: "entity_doc4.pdf", Id: 4, ContentType: "application/pdf", ContentLength: 0
                    }],
                    PostalCode: "250048", 
                    StreetName: "Meadow Vale", 
                    State: "Singapore", 
                    Country: "Singapore",
                    PrimaryActivity: "Maecenas venenatis tellus vitae massa dapibus auctor.",
                    PrimaryActivityDescription: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
                    SecondaryActivity: "Aliquam ac nulla vitae mi auctor accumsan.",
                    SecondaryActivityDescription: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy"
                }
            ],
            "IsSuccess": true,
            "Messages": [],
            "TotalRecordCount": 3
        }
    }
    else if (dataType === "citizen") {
        return {
            "Data": [
                {
                    Username: "publicuser1",
                    FirstName: "Public",
                    MiddleName: "",
                    LastName: "User",
                    LastUpdated: "10-Sep-2024",
                    Role: "Business Administrator",
                    Companies: "Sea Salty Bakes Pte Ltd, Salty Investment Pte Ltd, Healthy Wealthy & Wise Marketing, Sea Properties Ltd"
                },
                {
                    Username: "paultan",
                    FirstName: "Paul",
                    MiddleName: "",
                    LastName: "Tan",
                    LastUpdated: "10-Sep-2024",
                    Role: "Contractor",
                    Companies: "Sea Salty Bakes Pte Ltd"
                },
                {
                    Username: "publicuser2",
                    FirstName: "Public",
                    MiddleName: "",
                    LastName: "User",
                    LastUpdated: "10-Sep-2024",
                    Role: "Consultant",
                    Companies: "Salty Investment Pte Ltd"
                },
                {
                    Username: "georgelim",
                    FirstName: "George",
                    MiddleName: "",
                    LastName: "Lim",
                    LastUpdated: "10-Sep-2024",
                    Role: "Consultant",
                    Companies: "Healthy Wealthy & Wise Marketing"
                },
                {
                    Username: "publicuser123",
                    FirstName: "Public",
                    MiddleName: "",
                    LastName: "User",
                    LastUpdated: "10-Sep-2024",
                    Role: "Owner",
                    Companies: "Sea Properties Ltd"
                }
            ],
            "IsSuccess": true,
            "Messages": [],
            "TotalRecordCount": 2
        }
    }
    else return null;
}

function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

class ServerSideDataTableDemo2 extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dataType: this.props.dataType,
            gridData: [],
            currentPage: 1,
            recordCount: 0,
            filterText: { [FILTER]: "" },
            sortColumn: "",
            sortDir: "",
            width: window.innerWidth,
            renderMobileCardActions: this.props.renderMobileCardActions,
            toggleUpdate: false,
            isLoaded: false
        };
    }

    async componentDidMount() {
        const { currentPage, filterText, sortColumn, sortDir, dataType } = this.state;
        const { pageSize, loader, extraGetParams, getGridDataResponse, t } = this.props;
        const { currLang } = this.props.context;

        // Start loading
        loader.start();

        // Get grid data
        const response = await getGridData(dataType, currentPage, pageSize, filterText, sortColumn, sortDir, extraGetParams, currLang);

        // Done loading
        loader.done();
        if (response !== null) {
            const { IsSuccess, Data, TotalRecordCount } = response;

            if (getGridDataResponse !== undefined) {
                getGridDataResponse(response);
            }

            if (IsSuccess) {
                this.initGrid(Data, TotalRecordCount);
            }
            else {
                toastError(t(ERROR.LIST_RETRIEVAL_FAIL));
            }
        }
        else {
            toastError(t(ERROR.LIST_RETRIEVAL_FAIL));
        }
    }

    async componentDidUpdate(prevProps) {

        if (prevProps.toggleUpdate !== this.props.toggleUpdate) {
            const { currentPage, filterText, sortColumn, sortDir, dataType } = this.state;
            const { pageSize, loader, extraGetParams } = this.props;
            const { currLang } = this.props.context;

            // Start loading
            loader.start();

            // Get grid data
            const response = getGridData(dataType, currentPage, pageSize, filterText, sortColumn, sortDir, extraGetParams, currLang);

            // Done loading
            loader.done();

            // Update table state
            this.updateTableState(true, response, currentPage);
        }

        this.setAutocompleteOff();
    }

    componentWillMount() {
        window.addEventListener('resize', this.handleWindowSizeChange);
    };

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleWindowSizeChange);
    };

    handleWindowSizeChange = () => {
        this.setState({ width: window.innerWidth });
    };

    setAutocompleteOff = () => {
        var inputElements = document.getElementsByTagName("input");
        for (var i = 0; inputElements[i]; i++) {
            inputElements[i].setAttribute("autocomplete", "off");
        }
    }

    initGrid = (data, recordCount) => {
        this.setState({
            gridData: data,
            recordCount: recordCount,
            isLoaded: true
        });
    }

    updateTableState = (toToggle, response, currentPage) => {
        const { IsSuccess, Data, TotalRecordCount } = response.body;
        const { t } = this.props;

        if (response.success && IsSuccess) {
            //Get previous page's data when current's page data is empty (except for Page 1)
            if (Data !== undefined && Data.length === 0 && currentPage !== 1) {
                this.getPrev();
            } else {
                this.setState({
                    gridData: Data,
                    currentPage: currentPage,
                    recordCount: TotalRecordCount
                });
            }

            // Update Grid
            if (toToggle) {
                this.setState({
                    toggleUpdate: !this.state.toggleUpdate
                })
            }
        }
        else {
            toastError(t(ERROR.LIST_RETRIEVAL_FAIL));
        }
    }

    togglePaginationDisplay = () => {
        if (this.state.recordCount === 0) {
            return "no-pagination";
        }
        return "";
    }

    getNext = async () => {
        const { currentPage, filterText, sortColumn, sortDir, dataType } = this.state;
        const { pageSize, loader, extraGetParams } = this.props;
        const { currLang } = this.props.context;

        let nextPage = currentPage + 1;

        // Start loading
        loader.start();

        // Get grid data
        const response = getGridData(dataType, nextPage, pageSize, filterText, sortColumn, sortDir, extraGetParams, currLang);

        // Done loading
        loader.done();

        // Update table state
        this.updateTableState(true, response, nextPage);
    }

    getPrev = async () => {
        const { currentPage, filterText, sortColumn, sortDir, dataType } = this.state;
        const { pageSize, loader, extraGetParams } = this.props;
        const { currLang } = this.props.context;

        let prevPage = currentPage - 1;

        // Start loading
        loader.start();

        // Get grid data
        const response = getGridData(dataType, prevPage, pageSize, filterText, sortColumn, sortDir, extraGetParams, currLang);

        // Done loading
        loader.done();

        // Update table state
        this.updateTableState(true, response, prevPage);
    }

    getPage = async (pageNumber) => {
        const { filterText, sortColumn, sortDir, dataType } = this.state;
        const { pageSize, loader, extraGetParams } = this.props;
        const { currLang } = this.props.context;

        // Start loading
        loader.start();

        // Get grid data
        const response = getGridData(dataType, pageNumber, pageSize, filterText, sortColumn, sortDir, extraGetParams, currLang);

        // Done loading
        loader.done();

        // Update table state
        this.updateTableState(true, response, pageNumber);
    }

    getCurrentPage = (e) => {
        let page = parseInt(e.target.value, 10);
        this.getPage(page);
    }

    applyFilter = (filterText) => {
        const { minFilterChars } = this.props;
        const minFilterCharacters = (typeof minFilterChars === 'undefined' ? 0 : minFilterChars);
        const searchFilterLength = filterText[FILTER].length;

        return (searchFilterLength >= minFilterCharacters) || (searchFilterLength === 0);
    }

    getFilter = async (filterText) => {
        const { sortColumn, sortDir, dataType } = this.state;
        const { isCustomFilter, pageSize, extraGetParams } = this.props;
        const { currLang } = this.props.context;

        // const { loader } = this.props;
        // Construct filterText
        filterText = isCustomFilter ? filterText : { [FILTER]: filterText };

        const toToggle = this.hasSelectFilterChange(filterText, this.state.filterText);

        await this.setState({ filterText });

        if (this.applyFilter(filterText)) {

            // // Start loading
            // loader.start();

            // Get grid data
            const response = getGridData(dataType, 1, pageSize, filterText, sortColumn, sortDir, extraGetParams, currLang);

            // // Done loading
            // loader.done();

            await this.setState({
                isFilter: true
            })

            // Update table state
            this.updateTableState(toToggle, response, 1);
        }
    }

    hasSelectFilterChange = (currentFilterText, prevFilterText) => {
        let currentFilterTextToCompare = Object.assign({}, currentFilterText);
        let prevFilterTextToCompare = Object.assign({}, prevFilterText);

        // Exclude search filter
        delete currentFilterTextToCompare[FILTER];
        delete prevFilterTextToCompare[FILTER];

        return !_.isEqual(currentFilterTextToCompare, prevFilterTextToCompare);
    }

    getSort = async (sortProperties) => {
        let col = sortProperties.id;
        let dir = sortProperties.sortAscending === true ? "asc" : "desc";
        this.setState({
            sortColumn: col,
            sortDir: dir
        });

        const { filterText, dataType } = this.state;
        const { pageSize, loader, extraGetParams } = this.props;
        const { currLang } = this.props.context;

        // Reset PageNumber to 1 when sortBy column is changed
        const pageNum = 1;

        // Start loading
        loader.start();

        // Get grid data
        const response = getGridData(dataType, pageNum, pageSize, filterText, col, dir, extraGetParams, currLang);

        // Done loading
        loader.done();

        // Update table state
        this.updateTableState(false, response, pageNum);
    }

    Filter = (props) => {
        return (
            <input
                type="text"
                name="filter"
                defaultValue={this.state.filterText[FILTER]}
                className={props.className}
                placeholder="Filter"
                onChange={(e) => props.setFilter(e.target.value)}
            />
        );
    };

    getImageCard = () => {
        const { noResultsMessage, graphicUrl, renderActions } = this.props;
        const { gridData, isLoaded } = this.state;

        return (
            <div className="row grid-list">
                {isLoaded && (gridData === undefined || gridData.length === 0) ?
                    <p>{noResultsMessage}</p>
                    :
                    gridData.map((file, index) => {
                        return (
                            <React.Fragment key={index}>
                                <div className={graphicUrl === file.Path ? "card grid-card grid-card-highlighted" : "card grid-card"}>
                                    <div className="card-headers white-background">
                                        <img className="card-img-graphic-select" src={this.getPath(file)} alt="Thumbnail" />
                                    </div>
                                    <div className="card-body">
                                        <div className="card-title">{file.Title}</div>
                                        <div className="card-information">{file.CreatedDate}</div>
                                        {renderActions({
                                            RowData: gridData[index],
                                            className: "action-button-group"
                                        })}
                                    </div>
                                </div>
                            </React.Fragment>
                        );
                    })}
            </div>
        )
    }

    getPath = (file) => {
        if (file.ContentType.includes("image")) {
            return this.props.imageUrl + file.Path;
        }
        else {
            return "/images/file.png"
        }
    }
    
    desktopLayout = ({ Table, Pagination, Filter }) => {
        return (
            <div>
                <Filter />
                <Table />
                <Pagination />
            </div>
        )
    }

    mobileLayout = ({ Filter, Table }) => {
        return (
            <div>
                <Filter />
                <Table />
            </div>
        )
    }

    mobileTable = () => {
        const { gridData, currentPage, recordCount } = this.state;
        const { pageSize } = this.props;
        const NoOfPage = Math.ceil(recordCount / pageSize);

        return (
            <MobileCard
                data={gridData}
                getPrev={this.getPrev}
                onChange={this.getCurrentPage}
                value={currentPage}
                NoOfPage={NoOfPage}
                getNext={this.getNext}
                getFirst={this.getFirst}
                getLast={this.getLast}
                columns={this.props.columns}
                currentPage={this.state.currentPage}
                renderMobileCardActions={this.props.renderMobileCardActions}
                noResultsMessage={this.props.noResultsMessage}
                filterExcludedFieldsArray={this.props.filterExcludedFieldsArray}
                graphicUrl={this.props.graphicUrl}
            />
        )
    }

    getComponents = (isMobile) => {
        const { isCustomLayout, isCustomFilter, components, isImageCard } = this.props;

        let customComponents = getCustomComponents();
        let dataTableComponents = components === undefined ? Object.assign({}, customComponents) : components;
        dataTableComponents.Filter = isCustomFilter ? components.Filter : this.Filter;

        if (isMobile) {
            dataTableComponents.Table = this.mobileTable;
        } else {
            dataTableComponents.Table = isImageCard ? this.getImageCard : customComponents.Table;
        }

        if(isCustomLayout) {
            dataTableComponents.Layout = components.Layout;
        } else {
            dataTableComponents.Layout = isMobile ? this.mobileLayout : this.desktopLayout;
        }

        return dataTableComponents;
    }

    render() {

        const { gridData, currentPage, recordCount, width, toggleUpdate } = this.state;
        const { pageSize, noResultsMessage } = this.props;

        const isMobile = width <= 992;
        let colDef = getColDefinition(this.props);

        return (
            <div className={"smart-griddle-table " + this.togglePaginationDisplay()}>
                <Griddle
                    key={isMobile + " " + toggleUpdate}
                    data={gridData}
                    pageProperties={{
                        currentPage,
                        pageSize,
                        recordCount
                    }}
                    textProperties={
                        this.noResultsMessage = { noResultsMessage }
                    }
                    components={this.getComponents(isMobile)}
                    events={{
                        onNext: this.getNext,
                        onPrevious: this.getPrev,
                        onGetPage: this.getPage,
                        onFilter: this.getFilter,
                        onSort: this.getSort,
                        onFirst: this.getFirst,
                        onLast: this.getLast
                    }}>
                    <RowDefinition>
                        {colDef}
                    </RowDefinition>
                </Griddle>
            </div>
        )
    }
}

const withDirectionContext = WrappedComponent => {
  class DirectionOnPageContext extends React.Component {
    render() {
      return (
        <DirectionContextConsumer>
          {({ currLang }) => (
            <WrappedComponent
              context={{ currLang }}
              {...this.props}
            />
          )}
        </DirectionContextConsumer>
      );
    }
  }

  return DirectionOnPageContext;
};

export default withTranslation()(withLoader(withDirectionContext(ServerSideDataTableDemo2)));